module.exports = __webpack_public_path__ + "static/media/music-slash.a6889b75.svg";